(() => {
  const source = document.currentScript?.dataset.mailchimpSrc;
  if (!source) return;
  let started = false;
  function loadMailchimp() {
    if (started) return;
    started = true;
    document.removeEventListener('pointerdown', loadMailchimp);
    document.removeEventListener('keydown', loadMailchimp);
    if ([...document.scripts].some((script) => script.src === source)) return;
    const script = document.createElement('script');
    script.src = source;
    script.async = true;
    document.head.appendChild(script);
  }
  function scheduleMailchimp() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadMailchimp, { timeout: 2000 });
    } else {
      window.setTimeout(loadMailchimp, 1000);
    }
  }
  const parameters = new URLSearchParams(window.location.search);
  const emailCampaign = parameters.has('mc_cid') || parameters.has('mc_eid') ||
    /mailchimp/i.test(parameters.get('utm_source') || '');
  if (emailCampaign) {
    loadMailchimp();
    return;
  }
  document.addEventListener('pointerdown', loadMailchimp, { once: true, passive: true });
  document.addEventListener('keydown', loadMailchimp, { once: true });
  if (document.readyState === 'complete') {
    scheduleMailchimp();
  } else {
    window.addEventListener('load', scheduleMailchimp, { once: true });
  }
})();
